/**
 * TimelineLayout — DS Layout
 * Liste verticale chronologique avec ligne centrale et points de repère
 */

import styles from './TimelineLayout.module.css';

export interface TimelineItem {
  id: string;
  label: string;
  date: string;
  content: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'danger';
}

interface TimelineLayoutProps {
  items: TimelineItem[];
  className?: string;
}

const VARIANT_COLOR: Record<NonNullable<TimelineItem['variant']>, string> = {
  default: 'var(--hrl-purple)',
  success: 'var(--hrl-action)',
  warning: 'var(--hrl-warning)',
  danger: 'var(--hrl-danger)',
};

export function TimelineLayout({ items, className = '' }: TimelineLayoutProps) {
  return (
    <div className={`${styles.timeline} ${className}`}>
      {items.map((item) => (
        <div key={item.id} className={styles.item}>
          <div className={styles.marker} style={{ background: VARIANT_COLOR[item.variant ?? 'default'] }} />
          <div className={styles.body}>
            <div className={styles.meta}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.date}>{item.date}</span>
            </div>
            <div className={styles.content}>{item.content}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
